/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */
import { baseActions } from "document-model";
import { renownCredentialManagerActions } from "./gen/creators.js";

/** Actions for the RenownCredential document model */

export const actions = { ...baseActions, ...renownCredentialManagerActions };
